// removed by extract-text-webpack-plugin
module.exports = {"podGridColumn":"CwPodGridColumn-podGridColumn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpodgrid/CwPodGridColumn.scss
// module id = 382
// module chunks = 0